export function getSizeProps(props) {
    var _a;
    if (props.buttonSmall)
        props.buttonSize = 'small';
    if (props.buttonMedium)
        props.buttonSize = 'medium';
    if (props.buttonLarge)
        props.buttonSize = 'large';
    var classes = (_a = {},
        _a["button-size-".concat(props.buttonSize || 'medium')] = typeof props.buttonSize != 'number',
        _a);
    var styles = {};
    if (typeof props.buttonSize === 'number') {
        styles.width = props.buttonSize;
        styles.height = props.buttonSize;
    }
    return {
        classes: classes,
        props: {},
        styles: styles,
        variables: {}
    };
}
